import React, { Component } from 'react';
import TabPanelExpenseAccount from './TabPanelExpenseAccount'
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import styles from '../../styles/expenseAccount.module.css';
import { isAuthenticated } from '../../actions/authentication';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

class ExpenseAccount extends Component {

    constructor(props) {
        super(props);

        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleTitle();
        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:expenseAccount'));
    }

    render() {
        return (
            this.state.authenticated &&  <div className={styles.rootExpenseAccount}>
                <TabPanelExpenseAccount />
            </div>
        );
    }
}

ExpenseAccount.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(ExpenseAccount));